import React from "react";
import "./stylesheet/style.css";
import { CalendarOutline } from "react-ionicons";
import { useConfirm } from "material-ui-confirm";

interface IProps {
  title: string;
  description: string;
  dateInfo: string;
  activeStep: number;
  setActiveStep: (value: number) => void;
  onClearBasket: Function;
  premiere: boolean;
}

const HeaderStepper: React.FC<IProps> = ({
  title,
  description,
  dateInfo,
  activeStep,
  setActiveStep,
  onClearBasket,
  premiere,
}) => {
  const steps = [{ title: "Wybór miejsca" }, { title: "Wybór biletu" }, { title: "Podsumowanie" }];
  const confirm = useConfirm();

  const handleChangeStep = (targetStep: number) => {
    if (activeStep === 1 && targetStep === 0) {
      // confirm({
      //   title: "Czy na pewno chcesz to zrobić?",
      //   description: "Twój wybór zostanie anulowany a Ty wrócisz na stronę główną.",
      // })
      //   .then(() => {
      //     onClearBasket();
      //   })
      //   .catch(() => {});
      setActiveStep(0);
    } else {
      return null;
    }
  };

  return (
    <div className="header-stepper-wrapper glass-background">
      <div className="header-stepper-title">
        <div>
          <h1>{title}</h1>
          <p>
            {" "}
            {premiere && <span className="premiere-chip">Premiera</span>}
            {description}
          </p>
        </div>
        <h4>
          <CalendarOutline /> {dateInfo}
        </h4>
      </div>
      <div className="header-stepper">
        {steps.map((item, index) => (
          <div
            key={index}
            className={`header-stepper-step ${activeStep === index && "active"} ${
              index > activeStep && "step-disabled"
            }`}
            onClick={() => handleChangeStep(index++)}
          >
            <span className="circle">{index + 1}</span> {item.title}
            <div className={activeStep === index ? "header-stepper-step-underline" : ""} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default HeaderStepper;
